import '../styles/TitleWithText.scss'


function TitleWithText(){
    return(
        <div className="title-with-text">
            <h1 className="title-with-text__title">Projets</h1>
            <p className="title-with-text__text">
                Vous trouverez ici une sélection de projets professionnels, personnels et scolaires, autour du branding, du design UI/UX et du développement front-end.
                Ils illustrent mon approche globale : comprendre une problématique, concevoir une identité ou une interface cohérente, puis la traduire en une expérience claire et agréable à utiliser.
            </p>
        </div>
    )
}

export default TitleWithText